import React from 'react';
import {
  Card, CardContent, CardHeader, Stack, Typography, Box,
  IconButton,
} from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';

import type { TravelerPersonalDetails } from '@marageti/z4-sdk/lib/people';
import type { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import { formatBirthdayWithAge, formatResidence } from './traveler-personal-details.utils';

const {
  OutlinedUserCircleIcon,
  OutlinedHomeIcon,
  OutlinedCakeIcon,
  OutlinedPencilIcon,
} = OutlinedIcons;

type TravelerPersonalDetailsCardProps = {
  onEditClick?: () => void;
  personalDetails: TravelerPersonalDetails | undefined;
  countryCodes?: CountryCodeMap;
};

type DetailRowProps = {
  icon: React.ReactNode;
  label: string;
  value: string | undefined;
};

const DetailRow = ({ icon, label, value }: DetailRowProps) => (
  <Box display="flex" alignItems="flex-start" gap={1.5}>
    {icon}
    <Typography variant="body" color="text.primary">
      {label}
    </Typography>
    <Typography variant="body" color={value ? 'text.secondary' : 'common.black50'}>
      {value || 'Not recorded'}
    </Typography>
  </Box>
);

const TravelerPersonalDetailsCard = ({ onEditClick, personalDetails, countryCodes }: TravelerPersonalDetailsCardProps) => (
  <Card>
    <CardHeader
      title="Personal Details"
      titleTypographyProps={{ variant: 'h3' }}
      action={onEditClick ? (
        <IconButton onClick={onEditClick}>
          <OutlinedPencilIcon color="primary" fontSize="small" />
        </IconButton>
      ) : undefined}
      sx={{ pb: 0 }}
    />
    <CardContent>
      <Stack spacing={2}>
        <DetailRow
          icon={<OutlinedUserCircleIcon />}
          label="Preferred name"
          value={personalDetails?.preferredName}
        />
        <DetailRow
          icon={<OutlinedHomeIcon />}
          label="Residence"
          value={formatResidence(personalDetails, countryCodes)}
        />
        <DetailRow
          icon={<OutlinedCakeIcon />}
          label="Birthday"
          value={formatBirthdayWithAge(personalDetails?.birthday)}
        />
      </Stack>
    </CardContent>
  </Card>
);

export default TravelerPersonalDetailsCard;
